import { render, staticRenderFns } from "./AutomailModal.vue?vue&type=template&id=31382680&scoped=true"
import script from "./AutomailModal.vue?vue&type=script&lang=ts"
export * from "./AutomailModal.vue?vue&type=script&lang=ts"
import style0 from "./AutomailModal.vue?vue&type=style&index=0&id=31382680&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31382680",
  null
  
)

export default component.exports